import React, { ReactNode, useRef, useState } from "react"
import { BsArrowLeftCircle, BsArrowRightCircle } from "react-icons/bs";
import Slider, { Settings } from "react-slick";

export interface IContentItem {
    label?: string
    slideContent: ReactNode | string;
    linkedContent: ReactNode | string;
}

export interface ISectionWithCarouselColumnProps {
    className?: string;
    initialSlide?: number;
    columnsContent: IContentItem[];
    carouselProps?: Partial<Settings>;
}

export const SectionWithCarouselColumn: React.FC<ISectionWithCarouselColumnProps> = ({
    className = "",
    columnsContent,
    initialSlide = 0,
    carouselProps
}) => {

    const slider = useRef<any>(null)

    const onPrevButtonClickHandler = () => {
        slider.current.slickPrev()
    }
    const onNextButtonClickHandler = () => {
        slider.current.slickNext()
    }

    const getPrevSlideLabel = (currentIndex: number): string => {
        if (currentIndex == 0) {
            return columnsContent[columnsContent.length - 1].label ?? ""
        }
        else {
            return columnsContent[currentIndex - 1].label ?? ""
        }
    }

    const getNextSlideLabel = (currentIndex: number): string => {
        if (currentIndex == (columnsContent.length - 1)) {
            return columnsContent[0].label ?? ""
        }
        else {
            return columnsContent[currentIndex + 1].label ?? ""
        }
    }

    const [linkedContent, setLinkedContent] = useState(columnsContent[initialSlide].linkedContent)
    const [prevSlideLabel, setPrevSlideLabel] = useState(getPrevSlideLabel(initialSlide))
    const [nextSlideLabel, setNextSlideLabel] = useState(getNextSlideLabel(initialSlide))

    return (
        <section className={`section-carousel-column ${className} relative w-full flex flex-row flex-wrap items-stretch`}>
            <div className="linked-content-col w-full lg:w-1/2">
                {typeof (linkedContent) == "string" && (
                    <div dangerouslySetInnerHTML={{ __html: linkedContent }}></div>
                )}
                {typeof (linkedContent) != "string" && (
                    linkedContent
                )}
            </div>
            <div className="w-full lg:w-1/2 inverted flex flex-row flex-wrap items-start p-5 lg:px-20 lg:py-16">
                <div className="prev-btn-container w-1/2 flex flex-row justify-start items-center mb-8 gap-5">
                    <button type="button" onClick={onPrevButtonClickHandler}>
                        <BsArrowLeftCircle className="text-body-text-inverted text-xl lg:text-3xl" />
                    </button>
                    <span className="slide-label w-32">
                        {prevSlideLabel}
                    </span>
                </div>
                <div className="next-btn-container w-1/2 flex flex-row justify-end items-center mb-8 gap-5">
                    <span className="slide-label w-32 text-right">
                        {nextSlideLabel}
                    </span>
                    <button type="button" onClick={onNextButtonClickHandler}>
                        <BsArrowRightCircle className="text-body-text-inverted text-xl lg:text-3xl" />
                    </button>
                </div>
                <Slider
                    ref={slider}
                    className="h-full w-full"
                    dots={false}
                    arrows={false}
                    initialSlide={initialSlide}
                    afterChange={(index) => {
                        setLinkedContent(columnsContent[index].linkedContent)
                        setPrevSlideLabel(getPrevSlideLabel(index))
                        setNextSlideLabel(getNextSlideLabel(index))
                    }}
                    {...carouselProps}
                >
                    {columnsContent.map((item, index) => {
                        let slideContent = item.slideContent
                        if (typeof (slideContent) == "string") {
                            return (
                                <div key={index} dangerouslySetInnerHTML={{ __html: slideContent }}></div>
                            )
                        }
                        else {
                            return (
                                slideContent
                            )
                        }
                    })}
                </Slider>
            </div>
        </section>
    )
}

export default SectionWithCarouselColumn